import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';

import csharp from '../assets/c-sharp.svg';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';


import about01 from '../assets/about01.jpg';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import circle from '../assets/circle.svg';
import avatar from '../assets/avatar.png';
import avatarbg from '../assets/avatarbg.png';
import avatarbg1 from '../assets/avatarbg_1.png';
import avatarbg2 from '../assets/avatarbg_2.png';
import avatarcircle01 from '../assets/avatarbg_circle01.png';
import avatarcircle02 from '../assets/avatarbg_circle02.png';

export default {
  email,
  mobile,
  api,
  csharp,
  css,
  figma,
  git,
  html,
  javascript,
  node,
  react,
  redux,
  sass,
  typescript,
  about01,
  about02,
  about03,
  about04,
  circle,
  avatar,
  avatarbg,
  avatarbg1,
  avatarbg2,
  avatarcircle01,
  avatarcircle02,
};